<a
    class="w-full flex gap-y-6 flex-col bg-badge rounded-xl p-6 cursor-pointer h-full transition-all"
    [routerLink]="['/', 'transaction', handledTransaction.chain_name, handledTransaction.transaction_hash]"
>
    <div class="flex justify-between items-center gap-x-2 whitespace-nowrap">
        <div class="flex justify-between items-center gap-x-5 w-full">
            <div class="flex-1">
                <div class="text-base font-semibold">From</div>
                <div class="flex justify-start items-center">
                    <app-hexagon-img [imgUrl]="fromImg" class="w-9 inline-block mr-1"></app-hexagon-img>
                    <span class="text-xs text-sub-text inline-block align-middle truncate" style="width: calc(100% - 40px)">
                        {{handledTransaction.from_address | address}}
                    </span>
                </div>
            </div>

            <div class="flex-1 text-sm whitespace-nowrap">
                <div class="text-base font-semibold">To</div>
                <div class="flex justify-start items-center">
                    <app-hexagon-img [imgUrl]="toImg" class="w-9 inline-block mr-1"></app-hexagon-img>
                    <span class="text-xs text-sub-text inline-block align-middle truncate" style="width: calc(100% - 40px)">
                        {{handledTransaction.to_address | address}}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="flex justify-between items-center gap-x-2 whitespace-nowrap">
        <div class="flex justify-between items-center w-full gap-x-5">
            <div class="flex-1">
                <div class="mb-1">Method</div>
                <div class="truncate text-xs text-sub-text">{{handledTransaction.method || '-'}}</div>
            </div>

            <div class="flex-1">
                <div class="mb-1">Value</div>
                <div class="truncate text-xs text-sub-text">{{handledTransaction.value | kmb2:2}}</div>
            </div>
        </div>
    </div>

    <div *ngIf="handledTransaction?.actions?.length" class="text-xs text-sub-text">
        <div class="flex justify-start items-center gap-x-1.5">
            <span>{{handledTransaction.actions[0].display_action_type}} </span>

            <ng-container *ngIf="handledTransaction.actions[0].token.token_type === 'ERC20'">
                <span>{{handledTransaction.actions[0].token.value | kmb2:2 }}</span>
                <span>{{handledTransaction.actions[0].token.token_symbol}}</span>
                <img
                    *ngIf="handledTransaction.actions[0].token.token_logo_url"
                    [src]="handledTransaction.actions[0].token.token_logo_url"
                    class="w-4 h-4 rounded-sm object-cover"
                    alt=""
                />
            </ng-container>
            <ng-container *ngIf="handledTransaction.actions[0].token.token_type === 'ERC721'">
                <span>1</span>
                <img
                    *ngIf="handledTransaction.actions[0].token.token_logo_url"
                    [src]="handledTransaction.actions[0].token.token_logo_url"
                    class="w-4 h-4 rounded-sm object-cover"
                    alt=""
                />
            </ng-container>
        </div>
    </div>

    <div class="flex justify-between items-center">
        <div class="text-sub-text text-xs">
            <span class="pr-1">{{handledTransaction.age}}</span>
            <img
                class="w-5 h-5 inline-block align-middle"
                [src]="commonService.getChainImg(handledTransaction.chain_name)"
                [alt]="handledTransaction.chain_name"
            />
        </div>
    </div>
</a>
